import { MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { constants } from "../../constants/constants";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import {
  createCrisisPopup,
  updateCrisisPopup,
} from "../../utils/ApiCalls/CrisisPopup";
import { addlog } from "../../utils/ApiCalls/Logs";
import { LOG_ACTIONS } from "../../utils/Constant/LogConstant";
import { getVessels } from "../../utils/ApiCalls/SpecialPage";
import { checkFields } from "../../utils/Validation/checkFields";
import UploadFileImage from "../imageUpload/uploadFileImage";
import { uploadFile } from "../../utils/ApiCalls/Document";
import { uploadData } from "../../utils/ApiCalls/Upload";
import AltTextInput, { pickAltText } from "../AltTextInput/AltTextInput";

const CRISIS_POPUP_ALT_FIELDS = [
  "image_alt",
  "simplified_chinese_image_alt",
  "traditional_chinese_image_alt",
  "bahasa_image_alt",
];

const CrisisPopupInput = ({ crisispopup }) => {
  const [title, setTitle] = useState("");
  const [simplifiedChineseTitle, setSimplifiedChineseTitle] = useState("");
  const [traditionalChineseTitle, setTraditionalChineseTitle] = useState("");
  const [pagetitle, setpageTitle] = useState("");
  const [simplifiedChinesepageTitle, setSimplifiedChinesepageTitle] =
    useState("");
  const [traditionalChinesepageTitle, setTraditionalChinesepageTitle] =
    useState("");
  const [description, setDescription] = useState("");
  const [simplifiedChineseDescription, setSimplifiedChineseDescription] =
    useState("");
  const [traditionalChineseDescripton, setTraditionalChineseDescripton] =
    useState("");
  const [isActive, setIsActive] = useState(false);
  const [displayLocation, setDisplayLocation] = useState([]);
  const [{ userDetails }, dispatch] = useDataLayerValue();
  const [error, setError] = useState();
  const [vesselOptions, setVesselOptions] = useState([]);
  const [vessel, setVessel] = useState("");
  const navigate = useNavigate();
  const [buttonText, setButton] = useState("");
  const [simplifiedChineseButton, setSimplifiedChineseButton] = useState("");
  const [traditionalChineseButton, setTraditionalChineseButton] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [traditionalChineseFile, setTraditionalChineseFile] = useState(null);
  const [simplifiedChineseFile, setSimplifiedChineseFile] = useState(null);
  const [bahasaFile, setBahasaFile] = useState(null);
  const [bahasaTitle, setBahasaTitle] = useState("");
  const [bahasaPageTitle, setBahasaPageTitle] = useState("");
  const [bahasaDescription, setBahasaDescription] = useState("");
  const [bahasaButton, setBahasaButton] = useState("");
  const [buttonLink, setButtonLink] = useState(null);
  const [altText, setAltText] = useState({});


  useEffect(() => {
    if (crisispopup) {
      setSelectedFile(crisispopup.image);
      setSimplifiedChineseFile(crisispopup?.simplified_chinese_image);
      setTraditionalChineseFile(crisispopup?.traditional_chinese_image);
      setTitle(crisispopup?.title);
      setSimplifiedChineseTitle(crisispopup?.simplified_chinese_title);
      setTraditionalChineseTitle(crisispopup?.traditional_chinese_title);
      setpageTitle(crisispopup?.page_title);
      setSimplifiedChinesepageTitle(crisispopup?.simplified_chinese_page_title);
      setTraditionalChinesepageTitle(
        crisispopup?.traditional_chinese_page_title
      );
      setDescription(crisispopup?.description);
      setSimplifiedChineseDescription(
        crisispopup?.simplified_chinese_description
      );
      setTraditionalChineseDescripton(
        crisispopup?.traditional_chinese_description
      );
      setButton(crisispopup.button_text);
      setSimplifiedChineseButton(crisispopup.simplified_chinese_button);
      setTraditionalChineseButton(crisispopup.traditional_chinese_button);
      setButtonLink(crisispopup.button_link);
      setVessel(crisispopup.brand);
      setIsActive(crisispopup.is_active === 1);
      setBahasaFile(crisispopup?.bahasa_image);
      setBahasaTitle(crisispopup?.bahasa_title || "");
      setBahasaPageTitle(crisispopup?.bahasa_page_title || "");
      setBahasaDescription(crisispopup?.bahasa_description || "");
      setBahasaButton(crisispopup?.bahasa_button || "");
      setAltText(pickAltText(crisispopup, CRISIS_POPUP_ALT_FIELDS));
    }
  }, [crisispopup]);
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  const handleEnglishTitleChange = (content) => {
    setTitle(content);
  };

  const handleSimplifiedChineseTitleChange = (content) => {
    setSimplifiedChineseTitle(content);
  };

  const handleCheckboxChange = () => {
    setIsActive(!isActive);
  };
  const handleTraditionalChineseTitleChange = (content) => {
    setTraditionalChineseTitle(content);
  };

  useEffect(() => {
    getOptionLocation();
  }, []);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();
    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setVesselOptions(vessels);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
 
  const addcrisispopup = async (e) => {
    e.preventDefault();
    let dataValues = {
      title,
      simplified_chinese_title: simplifiedChineseTitle,
      traditional_chinese_title: traditionalChineseTitle,
      page_title: pagetitle,
      simplified_chinese_page_title: simplifiedChinesepageTitle,
      traditional_chinese_page_title: traditionalChinesepageTitle,
      description: description,
      simplified_chinese_description: simplifiedChineseDescription,
      traditional_chinese_description: traditionalChineseDescripton,
      brand: vessel,
      button_text: buttonText,
      simplified_chinese_button: simplifiedChineseButton,
      traditional_chinese_button: traditionalChineseButton,
      bahasa_title: bahasaTitle,
      bahasa_page_title: bahasaPageTitle,
      bahasa_description: bahasaDescription,
      bahasa_button: bahasaButton,
      is_active: isActive ? 1 : 0,
      ...altText,
    };
    console.log({ dataValues });

    let valid = checkFields(dataValues);
    console.log({ simplifiedChineseFile, traditionalChineseFile });
    if (selectedFile) {
      if (typeof selectedFile === "string") {
        dataValues.image = selectedFile.replace(constants.MEDIAURL + "/", "");
      } else {
        let image = await uploadData(
          selectedFile,
          undefined,
          typeof crisispopup?.image === "string"
            ? crisispopup.image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "")
            : null
        );
        if (image?.error) throw new Error(image.error);

        dataValues.image = image?.url;
      }
    } else {
      dataValues.image = "";
    }
    if (traditionalChineseFile) {
      if (typeof traditionalChineseFile === "string") {
        dataValues.traditional_chinese_image = traditionalChineseFile.replace(
          constants.MEDIAURL + "/",
          ""
        );
      } else {
        let image = await uploadData(
          traditionalChineseFile,
          undefined,
          typeof crisispopup?.traditional_chinese_image === "string"
            ? crisispopup.traditional_chinese_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "")
            : null
        );
        if (image?.error) throw new Error(image.error);

        dataValues.traditional_chinese_image = image?.url;
      }
    } else {
      dataValues.traditional_chinese_image = "";
    }
    if (simplifiedChineseFile) {
      if (typeof simplifiedChineseFile === "string") {
        dataValues.simplified_chinese_image = simplifiedChineseFile.replace(
          constants.MEDIAURL + "/",
          ""
        );
      } else {
        let image = await uploadData(
          simplifiedChineseFile,
          undefined,
          typeof crisispopup?.simplified_chinese_image === "string"
            ? crisispopup.simplified_chinese_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "")
            : null
        );
        if (image?.error) throw new Error(image.error);

        dataValues.simplified_chinese_image = image?.url;
      }
    } else {
      dataValues.simplified_chinese_image = "";
    }
    if (bahasaFile) {
      if (typeof bahasaFile === "string") {
        dataValues.bahasa_image = bahasaFile.replace(constants.MEDIAURL + "/", "");
      } else {
        let image = await uploadData(
          bahasaFile,
          undefined,
          typeof crisispopup?.bahasa_image === "string"
            ? crisispopup.bahasa_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "")
            : null
        );
        if (image?.error) throw new Error(image.error);
        dataValues.bahasa_image = image?.url;
      }
    } else {
      dataValues.bahasa_image = "";
    }

    if (valid) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: valid, type: "error" },
      });
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
      setError(valid);
    } else {
      setError();

      const values = {
        ...dataValues,
      };

      let data;
      if (crisispopup?.id) {
        data = await updateCrisisPopup(crisispopup.id, values);
      } else {
        data = await createCrisisPopup(values);
      }
      if (data?.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.error, type: "error" },
        });
        return;
      }

      addlog(
        crisispopup?.id ? LOG_ACTIONS.UPDATED : LOG_ACTIONS.CREATED,
        "Crisis Popup",
        { id: data?.id || crisispopup?.id, title },
        userDetails.id
      );
      if (!crisispopup.id) {
        navigate("/website/cms/crisis-page/crisis-popup");
      } else {
        navigate("/website/cms/crisis-page/crisis-popup");
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: "Values updated", type: "success" },
        });
      }
    }
  };
  return (
    <div>
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addcrisispopup}>
              <div className="card-body">
                <div className="row">
                  {/* Images — all 4 languages in one row */}
                  <UploadFileImage
                    className={"col-lg-3"}
                    mandatory={"*"}
                    width={427}
                    height={314}
                    image={
                      crisispopup?.image
                        ? `${constants.MEDIAURL}/${crisispopup?.image}`
                        : crisispopup?.image
                    }
                    label={"English Crisis Logo Image"}
                    placeholder={"Upload english Crisis Logo Image"}
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                  />
                  <UploadFileImage
                    className={"col-lg-3"}
                    mandatory={"*"}
                    width={427}
                    height={314}
                    image={
                      crisispopup?.simplified_chinese_image
                        ? `${constants.MEDIAURL}/${crisispopup?.simplified_chinese_image}`
                        : crisispopup?.simplified_chinese_image
                    }
                    label={"Simplified Chinese Crisis Logo Image"}
                    placeholder={"Upload Simplified Chinese Crisis Logo Image "}
                    selectedFile={simplifiedChineseFile}
                    setSelectedFile={setSimplifiedChineseFile}
                  />
                  <UploadFileImage
                    className={"col-lg-3"}
                    mandatory={"*"}
                    width={427}
                    height={314}
                    image={
                      crisispopup?.traditional_chinese_image
                        ? `${constants.MEDIAURL}/${crisispopup?.traditional_chinese_image}`
                        : crisispopup?.traditional_chinese_image
                    }
                    label={"Traditional Chinese Crisis Logo Image "}
                    placeholder={"Upload Traditional Chinese Crisis Logo Image "}
                    selectedFile={traditionalChineseFile}
                    setSelectedFile={setTraditionalChineseFile}
                  />
                  <UploadFileImage
                    className={"col-lg-3"}
                    width={427}
                    height={314}
                    image={
                      crisispopup?.bahasa_image
                        ? `${constants.MEDIAURL}/${crisispopup?.bahasa_image}`
                        : crisispopup?.bahasa_image
                    }
                    label={"Bahasa Crisis Logo Image"}
                    placeholder={"Upload Bahasa Crisis Logo Image"}
                    selectedFile={bahasaFile}
                    setSelectedFile={setBahasaFile}
                  />
                  <AltTextInput className="col-lg-3" label="English Crisis Logo Alt Text" field="image_alt" values={altText} setValues={setAltText} />
                  <AltTextInput className="col-lg-3" label="Simplified Chinese Crisis Logo Alt Text" field="simplified_chinese_image_alt" values={altText} setValues={setAltText} />
                  <AltTextInput className="col-lg-3" label="Traditional Chinese Crisis Logo Alt Text" field="traditional_chinese_image_alt" values={altText} setValues={setAltText} />
                  <AltTextInput className="col-lg-3" label="Bahasa Crisis Logo Alt Text" field="bahasa_image_alt" values={altText} setValues={setAltText} />
                  {/* Titles — all 4 languages in one row */}
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">English Title</label>
                      <ReactQuill
                        value={title}
                        onChange={handleEnglishTitleChange}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Simplified Chinese Title</label>
                      <ReactQuill
                        value={simplifiedChineseTitle}
                        onChange={handleSimplifiedChineseTitleChange}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Traditional Chinese Title</label>
                      <ReactQuill
                        value={traditionalChineseTitle}
                        onChange={handleTraditionalChineseTitleChange}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Bahasa Title</label>
                      <ReactQuill
                        value={bahasaTitle}
                        onChange={(e) => setBahasaTitle(e)}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  {/* Descriptions — all 4 languages in one row */}
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">English Description</label>
                      <ReactQuill
                        value={description}
                        onChange={(e) => { setDescription(e); }}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Simplified Chinese Description</label>
                      <ReactQuill
                        value={simplifiedChineseDescription}
                        onChange={(e) => setSimplifiedChineseDescription(e)}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Traditional Chinese Description</label>
                      <ReactQuill
                        value={traditionalChineseDescripton}
                        onChange={setTraditionalChineseDescripton}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Bahasa Description</label>
                      <ReactQuill
                        value={bahasaDescription}
                        onChange={(e) => setBahasaDescription(e)}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  {/* Button Text — all 4 languages in one row */}
                  <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Button Text</label>
                      <input
                        required
                        className="f_input"
                        type="text"
                        value={buttonText}
                        onChange={(e) => setButton(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Simplified Chinese Button Text</label>
                      <input
                        required
                        className="f_input"
                        type="text"
                        value={simplifiedChineseButton}
                        onChange={(e) => setSimplifiedChineseButton(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Traditional Chinese Button Text</label>
                      <input
                        required
                        className="f_input"
                        type="text"
                        value={traditionalChineseButton}
                        onChange={(e) => setTraditionalChineseButton(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Bahasa Button Text</label>
                      <input
                        className="f_input"
                        type="text"
                        value={bahasaButton}
                        onChange={(e) => setBahasaButton(e.target.value)}
                      />
                    </div>
                  </div>
                  {/* Page Titles — all 4 languages in one row */}
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">English Page Title</label>
                      <ReactQuill
                        value={pagetitle}
                        onChange={(e) => setpageTitle(e)}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Simplified Chinese Page Title</label>
                      <ReactQuill
                        value={simplifiedChinesepageTitle}
                        onChange={(e) => setSimplifiedChinesepageTitle(e)}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Traditional Chinese Page Title</label>
                      <ReactQuill
                        value={traditionalChinesepageTitle}
                        onChange={(e) => { setTraditionalChinesepageTitle(e); }}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Bahasa Page Title</label>
                      <ReactQuill
                        value={bahasaPageTitle}
                        onChange={(e) => setBahasaPageTitle(e)}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">
                        Choose Brand <span style={{ color: "red" }}> *</span>
                      </label>
                      <Select
                        required
                        style={{ width: "100%", height: "45px" }}
                        value={vessel}
                        onChange={(e) => setVessel(e.target.value)}
                      >
                        <MenuItem value={"genting"}>Dream Cruises</MenuItem>
                        <MenuItem value={"star"}>StarCruises</MenuItem>
                      </Select>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="iti_inner">
                      <div className="icheck-primary d-inline">
                        <input
                          type="checkbox"
                          id="customCheckbox4"
                          name="r10"
                          checked={isActive}
                          onChange={handleCheckboxChange}
                        />
                        <label htmlFor="customCheckbox4">
                          {isActive ? (
                            <p>
                              <span style={{ fontWeight: 600 }}>Active</span>
                            </p>
                          ) : (
                            <p>
                              <span style={{ fontWeight: 200 }}>Active</span>
                            </p>
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer text-right">
                <button className="btn main_submit">
                  {crisispopup.id ? "Update" : "Add"} Crisis Popup
                </button>
              </div>
            </form>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default CrisisPopupInput;
